import { Box, Table } from '@nimbus-ds/components';
import { Repeater } from 'commons/components';
import { TransferListHeader } from './TransferListHeader';
import TransferListRow from './TransferListRow';

const rowSkeleton = () => <TransferListRow.Skeleton />;

export function TransferListTableSkeleton() {
  return (
    <Box flexDirection="column" gap="2" display="flex">
      <Table>
        <TransferListHeader />
        <Table.Body>
          <Repeater times={5} item={rowSkeleton} />
        </Table.Body>
      </Table>
    </Box>
  );
}
